module.exports = __webpack_public_path__ + "static/messages_hero_dsktp-cc07dd6d6f3ac5d2ba797030da7595f1.png";